import React from "react";
import Grid from "@material-ui/core/Grid";
import logo from "../../images/logo.png";
import Typography from "@material-ui/core/Typography";

export default function About() {
  return (
      <Grid container>
        <Grid item lg></Grid>
        <Grid item style={{ marginTop: "10em" }}>
          <Grid container direction="column" alignItems="center">
            <Grid item>
              <img src={logo} alt={"Octolytics logo"} />
            </Grid>
            <Grid item style={{ marginTop: "1.5em" }}>
              <Typography variant="h6"> Version 0.0.1 (Beta)</Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item lg></Grid>
      </Grid>
  );
}
